import styled from "styled-components";


export const Section = styled.section`
  padding-top: 150px;
  width: 100%;
  margin: auto;
  margin-top: 150px;
  display: flex;
  align-items: center;
  flex-direction: column;

  


h2{
  margin-bottom: 100px;
}



a{
  margin-top: 120px;

}

button {
  font-size: 20px;
  width: 300px;
  padding: 10px;
  background-color: ${props => props.theme.backgroundColor};
  border-radius: 5px;
  border: 2px solid ${props => props.theme.siteColor};
  color: ${props => props.theme.siteColor};
  cursor: pointer;
  transition: all 0.4s;
}

button:hover {
  transform: scale(1.1);
  background-color: ${props => props.theme.siteColor};
  color: black;
}


@media screen and (max-width: 420px) {

  button{
    width: 200px;
  }
}

`
export const Container = styled.div`
  width: 100%;
  /* background-color: aqua; */
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;

  
 div{

  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  img{
    width: 400px;
  border: 1px solid ${props => props.theme.siteColor};
  box-shadow: 5px 5px 10px rgb(64, 65, 66);

  }

a{
  margin-top: 30px;
  margin-bottom: 30px;
}

button{
  color: black;
  width: 200px;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  background-color: ${props => props.theme.siteColor};
}

button:hover {
  background-color: ${props => props.theme.hover};
}


 }


 @media screen and (max-width: 420px) {
  div{
    padding: 0px;
    img{

   width: 320px;
}
button{
  width: 150px;
  padding: 5px;
}


  }
  
  

 }

 @media screen and (max-width: 340px) {
  div{
   
    img{

   width: 300px;
}


  }
  
  

 }

`

export const Private = styled.button`
  color: rgb(255, 255, 255) !important;
  background-color: rgb(146, 164, 179) !important;
  opacity: 0.3;
  cursor: not-allowed !important;
  margin-top: 30px;
  margin-bottom: 30px;
  z-index: 0 ;

`

